import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './advanceRow.module.scss';

const AdvanceRowHeader = () => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  return (
    <div className="d-none d-sm-block mb-2 text-muted font-weight-bold">
      <div className="row align-items-center no-gutters">
        <div className="col-sm-4 col-lg">
          {tLabels("advanceRowHeader.maturity")}
        </div>
        <div className="col-sm-4 col-lg">
          {tLabels("advanceRowHeader.currentAmount")} <span className="d-none d-lg-inline">{tLabels("advanceRowHeader.advances")}</span>
        </div>
        <div className={`col-sm-4 col-lg-auto ${styles.amountInputCol}`}>
          {tLabels("advanceRowHeader.requestedAmount")} <span className="d-none d-lg-inline">{tLabels("advanceRowHeader.advances")}</span>
        </div>
      </div>
    </div>
  )
}

export default AdvanceRowHeader;
